import { AxiosInstance } from 'axios';
import { SettingsRepository } from '~/model/repository/shift/SettingsRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): SettingsRepository => ({
    index() {
      return Repository.get(`${resource}`, { data: { errorHandle: false } });
    },
  });
